import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Jecanje",
  "description": "",
  "published": "2006-11-08T00:00:00.000Z",
  "redirect_from": ["/blog/jecanje/swizec/365"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ne vem kaj je bolj bedno, igra, ki sem jo danes videl, ali napredek mojega nanowrima, ampak katerokoli je, je bedno toliko, da jecam. Zgleda, da sem bil porinjen v nadleznostno pisateljsko blokado, ki ni posledica nezmosnosti pisanja, niti ne izvira iz pomankanja idej in Oziris pomagaj nima korena v nevoljanosti pisanja. Preprost razlog je, da vedno, ko se spravim pisat, pride nekaj vmes in me od tega odvrne, pa naj bo to nova epizoda super nanizanke, ali pa nekaj tako preprostega, kot je obisk kavarne z ljudmi namesto sam in iz tega sledoca neizvedljivost pisanja.`}</p>
    <p>{`Kar se tice igre, ki sem jo omenil, bila je to stvar, v katero sem bil prisiljen. Ogledali smo si jo s solo in smrdela je ravno toliko kot, ko sem si pred dvemi leti ogledal isto predstavo z istimi igralci in z isto kolicino nesmiselnosti in neuzitka. Zgodba je preprosto zanic in osebe so nezanimive, edina stvar, ki igri nekako povzdigne gledljivost je glavni igralec, ki svojo vlogo odigra odlicno in je celo zanimiv, skoda le, da besede, ki jih govori, niso. Podobno je kot kako Johnny Depp vsako svojo vlogo naredi odlicno, cetudi to pravzaprav ni.`}</p>
    <p>{`Nekaj odlicnega, kar sem danes videl, pa je tudi zadnja epizoda prve sezone internetne nanizanke `}<a parentName="p" {...{
        "href": "http://www.purepwnage.com/"
      }}>{`Pure Pwnage`}</a>{`, ki jo priporocam v ogled vsem, ki berete te besede.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      